import { render, staticRenderFns } from "./DemoBase.vue?vue&type=template&id=4fe8e241&scoped=true"
import script from "./DemoBase.vue?vue&type=script&lang=js"
export * from "./DemoBase.vue?vue&type=script&lang=js"
import style0 from "./DemoBase.vue?vue&type=style&index=0&id=4fe8e241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe8e241",
  null
  
)

export default component.exports